import { Injectable } from "@angular/core";
import { ThermalApi } from "../thermal-api";

@Injectable()
export class FaceApi {

    private model: string = 'face';

    constructor(
        private thermalApi: ThermalApi,
    ) {

    }

    create(pass: string, personId: any, faceId: any = '', imgBase64: any, isEasyWay: string = 'false') {
        const method: string = 'POST';
        const func: string = 'create';
        const params = new FormData();
        params.append('pass', pass);
        params.append('personId', personId);
        params.append('faceId', faceId);
        params.append('imgBase64', imgBase64);
        params.append('isEasyWay', isEasyWay);
        return this.thermalApi.request(method, this.model, func, params);
    }

    find(pass: string, personId: any,) {
        const method: string = 'POST';
        const func: string = 'find';
        const params = new FormData();
        params.append('pass', pass);
        params.append('personId', personId);
        return this.thermalApi.request(method, this.model, func, params);
    }

    deletePerson(pass: string, personId: any,) {
        const method: string = 'POST';
        const func: string = 'deletePerson';
        const params = new FormData();
        params.append('pass', pass);
        params.append('personId', personId);
        return this.thermalApi.request(method, this.model, func, params);
    }

}


// WEBPACK FOOTER //
// ./src/shared/thermal/services/face.api.ts